import React from "react";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";

// No public self-registration path: the landing screen is login-only. New
// users are added from inside the Dashboard's "Users" tab (AddUser
// embedded), which requires an authenticated session -- see the matching
// @login_required added to POST /api/auth/register in app.py.
function Shell() {
  const { user, checking } = useAuth();

  if (checking) {
    return <div style={{ color: "#8b949e", padding: 40, fontFamily: "monospace" }}>Loading...</div>;
  }

  if (user) return <Dashboard />;

  return <Login />;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Shell />
      </AuthProvider>
    </ThemeProvider>
  );
}
